/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mcp_Step_Sign_InInputs */

const en_mcp_step_sign_in = /** @type {(inputs: Mcp_Step_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in to Listening`)
};

const es_mcp_step_sign_in = /** @type {(inputs: Mcp_Step_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inicia sesión en Listening`)
};

/**
* | output |
* | --- |
* | "Sign in to Listening" |
*
* @param {Mcp_Step_Sign_InInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mcp_step_sign_in = /** @type {((inputs?: Mcp_Step_Sign_InInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mcp_Step_Sign_InInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mcp_step_sign_in(inputs)
	return en_mcp_step_sign_in(inputs)
});